
	export default {
		props: {
			rules: Object,
			value: {
				type: Array,
				default: () => []
			},
			checkboxesSelected: {
				type: Array, 
				default: () => []
			}
		},
		data() {
			return {
				isDisabledSelect: false,
				isDisabledInput: false,
				input: '',
				select: 'Make a choice',
				selects: [
					{
						title: 'Metoprolol',
						mg: 200
					},
					{
						title: 'Carvedilol',
						mg: 50
					},
					{
						title: 'Bisoprolol',
						mg: 10
					},
					{
						title: 'Nevibolol',
						mg: 10
					},
					{
						title: 'Other',
						mg: 0
					},
				],
				checkboxes: [
					{
						title: "ACEi/ARB", 
						fullTitle: 'ACEi/ARB',
						type: 'radio',
						name: 'radio-1'
					},
					{
						title: "ARNI", 
						fullTitle: 'Angiotension Receptor Neprilysin Inhibitor',
						type: 'radio',
						name: 'radio-1'
					},
					{
						title: "Anticoagulant", 
						fullTitle: 'Anticoagulant',
						type: 'checkbox',
						name: 'checkbox'
					},
					{
						title: "SGLTi", 
						fullTitle: 'Sodium Glucose Co-Transporter Inhbitor',
						type: 'checkbox',
						name: 'checkbox'
					},
					{
						title: "GLP1-RA", 
						fullTitle: 'GLP-1 Receptor Antagonist.',
						type: 'checkbox',
						name: 'checkbox'
					},
					{
						title: "Statin", 
						fullTitle: 'Statin',
						type: 'checkbox',
						name: 'checkbox'
					},
					{
						title: "Additional LLT", 
						fullTitle: 'Additional LLT',
						type: 'checkbox',
						name: 'checkbox'
					},
					{
						title: "Evi. Based BB >50% max Dose", 
						fullTitle: 'Evi. Based BB >50% max Dose',
						type: 'radio',
						name: 'radio-2'
					},
					{
						title: "Evi. Based BB <50% max Dose", 
						fullTitle: 'Evi. Based BB <50% max Dose',
						type: 'radio',
						name: 'radio-2'
					},
					{
						title: "nsMRA", 
						fullTitle: 'Non-steroidal Mineralocorticoid Receptor Antagonist',
						type: 'checkbox',
						name: 'checkbox'
					},
					{
						title: "sMRA", 
						fullTitle: 'Steroidal Mineralocorticoid Receptor Antagonist',
						type: 'checkbox',
						name: 'checkbox'
					},
					{
						title: "BetaBlocker", 
						fullTitle: 'Beta Blocker',
						type: 'checkbox',
						name: 'checkbox'
					}
				]
			}
		},
		mounted() {
			if (this.value.includes('BetaBlocker')) {
                this.isDisabledSelect = true;
            }
			
			this.$emit('disabled', false);
		},
		watch: {
			input(newValue) {
				if (this.isDisabledInput) {
					let input = Number(newValue);
					let risk = 0;

					if (this.select == 'Metoprolol') {
						if (input >= 100) risk = 1;
						if (input > 0 && input <= 100) risk = 0.5;
						if (input == 0) risk = 0;
					}

					if (this.select == 'Carvedilol') {
						if (input >= 25) risk = 1;
						if (input > 0 && input <= 25) risk = 0.5;
						if (input == 0) risk = 0;
					}

					if (this.select == 'Bisoprolol' || this.select == 'Nevibolol') {
						if (input >= 5) risk = 1;
						if (input > 0 && input <= 5) risk = 0.5;
						if (input == 0) risk = 0;
					}

					let updatedValue = [...this.value];
					let index = updatedValue.findIndex(item => item.BetaBlockerRisk !== undefined);

					if (index !== -1) {
						updatedValue[index] = { BetaBlockerRisk: risk };
					} else {
						updatedValue.push({ BetaBlockerRisk: risk });
					}

					this.$emit('input', updatedValue);
				}
			}
		},
		methods: {
			updateSelect() {
				console.log(this.select);
				if (this.select === 'Make a choice' || this.select === 'Other') {
					this.isDisabledInput = false;
				} else {
					this.isDisabledInput = true;
				}
			},
			updateValue(event, option) {
				let newValue = [...this.value];
				const checkbox = this.checkboxes.find(cb => cb.title === option);

				if (event.target.type == 'radio') {
					newValue = newValue.filter(v => {
			            const cb = this.checkboxes.find(c => c.title === v);
			            if (!cb) return true;
			            if (cb.type !== 'radio') return true;
			            return cb.name !== checkbox.name;
			        });

					newValue.push(option);
				} else {
					if (event.target.checked) {
						if (!newValue.includes(option)) {
							newValue.push(option);
						}
					} else {
						newValue = newValue.filter(o => o !== option);
					}
				}

				if (newValue.includes('BetaBlocker')) {
	                this.isDisabledSelect = true;
	            } else {
	                this.isDisabledSelect = false;
	                this.isDisabledInput = false;
	                this.input = 0;
					this.select = 'Make a choice';
	            }

				this.$emit('input', newValue);
			},
			isRuleEnabled(ruleName) {
			 	return this.rules[ruleName] === true;
			}
		}
	}
